import { render, staticRenderFns } from "./ExistingSpousalSupportFinalOrder.vue?vue&type=template&id=f7840cb8"
import script from "./ExistingSpousalSupportFinalOrder.vue?vue&type=script&lang=ts"
export * from "./ExistingSpousalSupportFinalOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports